import type { Translate } from "../../translation/types";

export const convertKgToGrams = (weightInKg: number | string): number => {
  if (typeof weightInKg === "string") {
    const parsedWeight = parseFloat(weightInKg);
    if (isNaN(parsedWeight)) {
      console.warn("cannot parse weight of ", weightInKg);
      return NaN;
    }
    weightInKg = parsedWeight;
  }

  const gramsInKg = 1000;
  const weightInGrams = weightInKg * gramsInKg;
  return weightInGrams;
};

export const formattedWeight = (__: Translate, weightInKg: number | string): string => {
  const weightInGrams = convertKgToGrams(weightInKg);
  return __("productspecification.attribute.formattedWeightInGrams", [weightInGrams]);
};
